<app-navbar-style-one></app-navbar-style-one>

<div class="menu-page account-section">
    <div class="container-fluid">
        <div class="content-wrapper">
            <!-- Left Image -->
            <div class="left-image">
                <img src="../../../assets/img/home2/header1.jpg" alt="Chef seasoning steak">
            </div>

            <!-- Center Content -->
            <div class="center-content">
                <h2>{{ 'My Account' | titlecase}}</h2>
                <p>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
                </p>
            </div>

            <!-- Right Images -->
            <div class="right-images">
                <img src="../../../assets/img/home2/header3.jpg" alt="Stuffed mushroom dish">
                <img src="../../../assets/img/home2/header2.jpg" alt="Gourmet burger with fries">
            </div>
        </div>
    </div>
</div>

<section class="orderDetails-section mt-5 mb-5">
    <div class="container">
        <div class="address-container" *ngIf="!isLoading && orderDetails">
            <h3 class="section-title text-center">Order Details #{{orderDetails.orderId}}</h3>
            
            <!-- Vendor Info -->
            <div class="vendor-card">
                <img src="../../../../assets/img/logo.png" 
                     class="vendor-avatar">
                <div class="vendor-info">
                    <h4>Roma Pizza</h4>
                    <!-- <div class="order-status status-ordered">
                        {{ 'ordered' | titlecase }}
                    </div> -->
                    <div class="order-status" [ngClass]="{
                        'status-ordered': orderDetails?.status != 'canceled',
                        'status-canceled': orderDetails?.status === 'canceled',
                        'status-success': orderDetails?.status === 'accepted'
                    }">
                        {{ orderDetails?.status | titlecase }}
                    </div>
                </div>
            </div>

            <!-- Order Summary -->
            <div class="order-summary">
                <div class="summary-item">
                    <span class="summary-label">Order Date:</span>
                    <span class="summary-value">{{ orderDetails.orderedAt | date:'dd/MM/yyyy' }}</span>
                </div>

                <div class="summary-item">
                    <span class="summary-label">Order Time:</span>
                    <span class="summary-value">{{ orderDetails.orderedAt | date:'hh:mm a' }}</span>
                </div>

                <div class="summary-item">
                    <span class="summary-label">Delivery Time:</span>
                    <span class="summary-value" *ngIf="orderDetails.deliveryTime && orderDetails.deliveryTime != null">{{ orderDetails.deliveryTime +' min' }}</span>
                    <span class="summary-value" *ngIf="!orderDetails.deliveryTime || orderDetails.deliveryTime == null">Not Specified Yet</span>
                </div>
                
                <div class="summary-item">
                    <span class="summary-label">Delivery Address:</span>
                    <span class="summary-value">{{ orderDetails.address }}</span>
                </div>
                
                <div class="summary-item">
                    <span class="summary-label">Payment Method:</span>
                    <span class="summary-value">{{ orderDetails.paymentMethod }}</span>
                </div>
                
                <div class="summary-item">
                    <span class="summary-label">Notes:</span>
                    <span class="summary-value">{{  orderDetails.deliveryNote || '-' }}</span>
                </div>
            </div>

            <!-- Products List -->
            <!-- <div class="products-list"> -->
                <!-- <p>
                    <span class="list-title">Products</span>
                </p> -->

                <!-- <div class="product-item row" *ngFor="let product of orderDetails.products">
                    <div class="product-info col-md-4 col-sm-6">
                        <div class="d-flex align-items-center">
                            <img src="{{product.avatar}}" class="product-image" alt="Product">
                            <div class="product-info">
                                <h5>{{product.name}}</h5>
                                <small>{{product.type | titlecase}}</small>
                            </div>
                        </div>
                    </div>
                    <div class="product-quantity text-center col-md-4 col-sm-3">
                        {{product.quantity}} × {{product.price | currency:'USD':'symbol':'1.0-0'}}
                    </div>
                    <div class="product-total text-center col-md-4 col-sm-3">
                        {{product.quantity * product.price | currency:'USD':'symbol':'1.0-0'}}
                    </div>
                </div> -->

                <!-- Products List -->
                <div class="products-list">
                    <p>
                        <span class="list-title">Products</span>
                    </p>
                    <div class="product-item row mb-3" *ngFor="let product of orderDetails.products; let i = index">
                        <div class="product-info col-md-4 col-sm-6">
                            <div class="d-flex align-items-center">
                                <img [src]="product.avatar" class="product-image me-3" alt="Product" style="width: 60px; height: 60px; object-fit: cover;">
                                <div class="product-info">
                                    <h5 class="mb-1">{{product.name}}</h5>
                                    <small class="text-muted">{{product.type | titlecase}}</small>
                                    
                                    <!-- Display Extras -->
                                    <div *ngIf="hasExtras(product)" class="mt-1">
                                        <div *ngFor="let extra of product.extras" class="extra-item">
                                            <small class="text-muted">+ {{extra.name}} 
                                                <span *ngIf="extra.quantity > 1">({{extra.quantity}}x)</span>
                                                {{(extra.price * (extra.quantity || 1) * product.quantity) | currency:'USD':'symbol':'1.2-2'}}
                                            </small>
                                        </div>
                                    </div>
                                    
                                    <!-- Display Sides -->
                                    <div *ngIf="hasSides(product)" class="mt-1">
                                        <div *ngFor="let side of product.sides" class="side-item">
                                            <small class="text-muted">+ {{side.name}} 
                                                <span *ngIf="side.quantity > 1">({{side.quantity}}x)</span>
                                                {{(side.price * (side.quantity || 1) * product.quantity) | currency:'USD':'symbol':'1.2-2'}}
                                            </small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <div class="product-quantity text-center col-md-4 col-sm-3">
                            <div class="mb-1">{{product.quantity}} × {{roundToNearestTen(product.price) | currency:'USD':'symbol':'1.2-2'}}</div>
                            
                            <!-- Show extras breakdown if any -->
                            <div *ngIf="hasExtras(product)" class="breakdown">
                                <small class="text-muted">
                                    + Extras: {{calculateExtrasTotal(product.extras, product.quantity) | currency:'USD':'symbol':'1.2-2'}}
                                </small>
                            </div>
                            
                            <!-- Show sides breakdown if any -->
                            <div *ngIf="hasSides(product)" class="breakdown">
                                <small class="text-muted">
                                    + Sides: {{calculateSidesTotal(product.sides, product.quantity) | currency:'USD':'symbol':'1.2-2'}}
                                </small>
                            </div>
                        </div>
                        
                        <div class="product-total text-center col-md-4 col-sm-3">
                            <strong>{{calculateProductTotal(product) | currency:'USD':'symbol':'1.2-2'}}</strong>
                        </div>
                    </div>

                    <!-- Custom Products List -->
                    <div class="custom-products-list mt-4" *ngIf="hasCustomProducts()">
                        <p>
                            <span class="list-title">Custom Products</span>
                        </p>
                        <div class="product-item row mb-3" *ngFor="let customProduct of orderDetails.custom_products; let i = index">
                            <div class="product-info col-md-4 col-sm-6">
                                <div class="d-flex align-items-start">
                                    <img [src]="customProduct.category?.avatar" class="product-image me-3" alt="Custom Product" style="width: 60px; height: 60px; object-fit: cover;">
                                    <div class="product-info">
                                        <h5 class="mb-1">{{customProduct.category?.name}} (Custom)</h5>
                                        <small class="text-muted">{{customProduct.subCategory?.name}} • Size: {{customProduct.category?.selected_size?.name}}</small>
                                        
                                        <!-- Display Ingredients -->
                                        <div *ngIf="hasIngredients(customProduct)" class="mt-1">
                                            <div *ngFor="let ingredient of customProduct.ingredients" class="ingredient-item">
                                                <small class="text-muted">
                                                    + {{ getIngredientDisplay(ingredient) }}
                                                    {{ (ingredient.totalPrice * customProduct.quantity) | currency:'USD':'symbol':'1.2-2' }}
                                                </small>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="product-quantity text-center col-md-4 col-sm-3">
                                <div class="mb-1">{{customProduct.quantity}} × Custom Pizza</div>
                                
                                <!-- Show breakdown -->
                                <div class="breakdown">
                                    <small class="text-muted">
                                        Base: {{ calculateCustomProductBasePrice(customProduct) | currency:'USD':'symbol':'1.2-2' }}
                                    </small>
                                </div>
                                
                                <!-- Show ingredients breakdown if any -->
                                <div *ngIf="hasIngredients(customProduct)" class="breakdown">
                                    <small class="text-muted">
                                        + Ingredients: {{ calculateIngredientsTotal(customProduct.ingredients, customProduct.quantity) | currency:'USD':'symbol':'1.2-2' }}
                                    </small>
                                </div>
                            </div>
                            
                            <div class="product-total text-center col-md-4 col-sm-3">
                                <strong>{{ calculateCustomProductTotal(customProduct) | currency:'USD':'symbol':'1.2-2' }}</strong>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Order Total -->
            <div class="order-total mt-4">
                <div class="total-row d-flex justify-content-between py-2">
                    <span>Subtotal</span>
                    <span>
                        {{ calculateSubtotal() | currency:'USD':'symbol':'1.2-2' }}
                    </span>
                </div>
                
                <!-- Delivery Fee -->
                <div class="total-row d-flex justify-content-between py-2" *ngIf="orderDetails.deliveryCost">
                    <span>Delivery fee</span>
                    <span>
                        {{ getRoundedDeliveryCost() | currency:'USD':'symbol':'1.2-2' }}
                    </span>
                </div>
                
                <!-- Service Fee -->
                <div class="total-row d-flex justify-content-between py-2" *ngIf="orderDetails.serviceCost">
                    <span>Service fee</span>
                    <span>
                        {{ getRoundedServiceCost() | currency:'USD':'symbol':'1.2-2' }}
                    </span>
                </div>
                
                <!-- Tax (if separate from service cost) -->
                <div class="total-row d-flex justify-content-between py-2" *ngIf="orderTax > 0">
                    <span>Tax</span>
                    <span>
                        {{ getTaxAmount() | currency:'USD':'symbol':'1.2-2' }}
                    </span>
                </div>
                
                <!-- Tips -->
                <div class="total-row d-flex justify-content-between py-2" *ngIf="orderTips > 0">
                    <span>Tips</span>
                    <span>
                        {{ getRoundedTips() | currency:'USD':'symbol':'1.2-2' }}
                    </span>
                </div>
                
                <!-- Grand Total -->
                <div class="total-row d-flex justify-content-between py-2 mt-3" style="border-top: 1px solid #b6b6b6;">
                    <span><strong>Total</strong></span>
                    <span>
                        <strong>{{ calculateTotal() | currency:'USD':'symbol':'1.2-2' }}</strong>
                    </span>
                </div>
            </div>

            <!-- Show message if no products -->
            <div class="text-center mt-4" *ngIf="!hasAnyProducts()">
                <p class="text-muted">No products found in this order.</p>
            </div>
        </div>

        <div class="address-container text-center" *ngIf="isLoading">
            <div class="spinner-grow" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
        </div>
    </div>
</section>

<app-footer-style-two></app-footer-style-two>